/*
 * Views for the List region of the substitutions page
 */

define([
  "marionette",
  "modules/reportSplit/groups/groupTiles/template/tileGrid.html",
  "modules/reportSplit/groups/groupTiles/template/tile.html",
], function (Marionette, GroupTileTemplate, GroupTile) {
  var GroupTilesView = {};

  GroupTilesView.tile = Marionette.ItemView.extend({
    template: GroupTile,
    tagName: "li",
    className: "reportTile",
    triggers: {
      click: "click:report",
    },
    modelEvents: {
      change: "render",
    },
  });

  GroupTilesView.tileGroup = Marionette.CompositeView.extend({
    className: "max-height",
    template: GroupTileTemplate,
    itemViewContainer: "ul",
    itemView: GroupTilesView.tile,
    collectionEvents: {
      sort: "render",
    },
  });

  return GroupTilesView;
});
